// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui';
import jQuery from 'jquery';
import 'element-ui/lib/theme-chalk/index.css';
import axios from 'axios';

window.axios = axios;
window.$ = jQuery;

if(window.location.href.indexOf("localhost") < 0) { //serve only HTTP

    if (location.protocol != 'https:')
    {
      location.href = 'https:' + window.location.href.substring(window.location.protocol.length);
    }
}

Vue.config.productionTip = false

Vue.use(ElementUI);
/* eslint-disable no-new */
window.app = new Vue({
  el: '#app',
  router,
  components: { App },
  data(){
    return {
      secret: false,
      domains: null
    }
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js